/**
 * Notification helper
 *
 * Central dispatcher for the application toast system. Services and tools
 * surface user feedback by dispatching the 'yap:notify' event, which is
 * consumed by the NotificationHost (Chakra toasts).
 */
export type NotifyStatus = 'info' | 'success' | 'warning' | 'error';

export function notify(message: string, status: NotifyStatus = 'info'): void {
    window.dispatchEvent(
        new CustomEvent('yap:notify', { detail: { message, status } })
    );
}
